(() => {
  let framePending = false;

  const updateScrollControl = () => {
    const control = document.querySelector('[data-feeling-scroll-control]');
    const sections = [...document.querySelectorAll('[data-feeling-scroll-section]')];
    if (!control || sections.length < 2) return;

    const marker = window.innerHeight * .45;
    let currentIndex = 0;
    sections.forEach((section, index) => {
      if (section.getBoundingClientRect().top <= marker) currentIndex = index;
    });
    const isPageBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
    if (isPageBottom) currentIndex = sections.length - 1;

    const currentSection = sections[currentIndex];
    const text = control.querySelector('[data-feeling-scroll-text]');
    const arrow = control.querySelector('[data-feeling-scroll-arrow]');
    const isFinalSection = currentIndex === sections.length - 1;
    const targetSection = isFinalSection ? sections[0] : sections[currentIndex + 1];
    const prefix = control.dataset.scrollPrefix || 'SCROLL TO';
    const backLabel = control.dataset.backLabel || 'BACK TO TOP';
    const targetLabel = targetSection.getAttribute('data-feeling-scroll-label') || targetSection.id;
    const controlLabel = isFinalSection ? backLabel : `${prefix} ${targetLabel}`;
    const isOnContent = currentIndex > 0;
    const isOnDark = isOnContent && currentSection.matches('[data-feeling-scroll-tone="dark"]');

    control.setAttribute('href', `#${targetSection.id}`);
    control.setAttribute('aria-label', controlLabel);
    control.classList.toggle('is-on-content', isOnContent);
    control.classList.toggle('is-on-dark', isOnDark);
    control.classList.toggle('is-final', isFinalSection);
    if (text) text.textContent = controlLabel;
    if (arrow) arrow.textContent = isFinalSection ? '↑' : '↓';
  };

  const scheduleUpdate = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(() => {
      updateScrollControl();
      framePending = false;
    });
  };

  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:unload', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, {passive: true});
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-feeling-scroll-control]');
    if (!control) return;

    const target = document.querySelector(control.hash);
    if (!target) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth'});
  });

  updateScrollControl();
})();
